import React from 'react';
import Sticky from 'react-stickynode';
import { StickyWrap } from './styled';
const StickyContainer = ({ children, setSticky }) => {
    const handleStateChange = (status) => {
        if (status.status === Sticky.STATUS_FIXED) {
            setSticky(true);
        }
        else {
            setSticky(false);
        }
    };
    return (React.createElement(StickyWrap, null,
        React.createElement(Sticky, { onStateChange: handleStateChange },
            React.createElement(React.Fragment, null, children))));
};
export default StickyContainer;
//# sourceMappingURL=StickyContainer.js.map